module.exports = __webpack_public_path__ + "media/10n.d3e358c9.mp4";